"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const common_1 = require("@Const/common");
const Button_1 = require("@Components/Buttons/Button");
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const TableRow = ({ className, tableRow, removableCells, onRemoveCellClicked, onExpandCellClicked, defaultExpanded = false, }) => {
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(defaultExpanded);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('table-row', className) },
        tableRow.subTables && (react_1.default.createElement("div", { className: 'expand-table-cell table-cell', onClick: () => {
                const expanded = !isExpanded;
                setIsExpanded(expanded);
                onExpandCellClicked && onExpandCellClicked(expanded);
            } },
            react_1.default.createElement("img", { src: isExpanded ? common_1.ICONS.chevron_drop_up : common_1.ICONS.chevron_drop_down, alt: 'expand-cell-toggle' }))),
        tableRow.cells.map((cell, index) => (react_1.default.createElement("div", { className: 'table-cell', key: `row-${index}` }, cell))),
        tableRow.cells.length > 0 && removableCells && (react_1.default.createElement("div", { className: 'remove-cell table-cell', "data-testid": 'remove-cell' },
            react_1.default.createElement(Button_1.Button, { disabled: !tableRow.removable, mainColor: true, type: 'tertiary', icon: common_1.ICONS.trashCan, onClick: () => {
                    onRemoveCellClicked && onRemoveCellClicked(tableRow.removeCellIdentifier);
                } })))));
};
exports.default = TableRow;
